/* eslint-disable react-hooks/exhaustive-deps */
import { GridColDef } from "@mui/x-data-grid";
import { AppTable, DeleteConfirmDialog } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks/useRequest";
import { IDownloadExcelRequest, IPaginationRequest } from "model";
import { IPaginateApiResponse } from "model/Common/IPaginateApiResponse";
import { ICompany } from "model/Company/ICompany";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  CompanyActions,
  DownloadActions,
  MasterDataActions,
} from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { CompanyApiService } from "services";
import { CURRENT_PAGE_SIZE, EXPORT_FILE_NAME, FIRST_PAGE } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

const CustomerConfiguration = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const data = useAppSelector(
    (state) => state.MasterDataReducer.company.data
  ) as IPaginateApiResponse<any>;
  const action = useAppSelector((state) => state.CompanyReducer.action);
  const downloading = useAppSelector(
    (state) => state.AppConfigReducer.downloading
  );

  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [itemSelected, setItemSelected] = useState<ICompany>();
  const [refresh, setRefresh] = useState(false);
  const [request, setRequest] = useState<IPaginationRequest>({
    pageNumber: FIRST_PAGE,
    pageSize: CURRENT_PAGE_SIZE,
  });

  const { loading, result } = usePaginationRequest<
    IPaginationRequest,
    ICompany[]
  >(
    request,
    CompanyApiService.getAllCompanies,
    [],
    {
      refresh: refresh,
    },
    () => {
      setRefresh(false);
    }
  );

  const onClickAddNew = () => {
    history.push(`${location.pathname}/new`);
  };

  const onPressEdit = (item: any) => {
    history.push({
      pathname: `${location.pathname}/edit/${item.id}`,
      state: {
        item: JSON.stringify(item),
      },
    });
  };

  const onPressDelete = (item: any) => {
    setItemSelected(item);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteCompany = () => {
    _getDeleteCompany(itemSelected?.id!);
  };
  const deleteCompanySuccessfully = action.includes(
    CompanyActions.deleteCompany.successName
  );

  const _clearAction = () => {
    dispatch(CompanyActions.clearAction.request());
  };

  const _getDeleteCompany = (id: string) => {
    dispatch(
      CompanyActions.deleteCompany.request({
        id: id,
      })
    );
  };

  const handlePageChange = (pageNumber: number) => {
    setRequest({ ...request, pageNumber: pageNumber });
  };
  const handleSearchTextChange = (searchText: string) => {
    setRequest({ ...request, pageNumber: FIRST_PAGE, searchText: searchText });
  };

  const _handlePageSizeChange = (pageSize: number) => {
    setRequest({ ...request, pageSize: pageSize });
  };

  const _downloadCompanyMasterData = () => {
    const params: IDownloadExcelRequest = {
      ...request,
      pageSize: (result as IPaginateApiResponse<ICompany[]>).totalRecords,
      pageNumber: FIRST_PAGE,
      fileName: EXPORT_FILE_NAME.companyMasterData,
    };
    dispatch(DownloadActions.downloadCompanyMasterData.request(params));
  };

  useEffect(() => {
    if (deleteCompanySuccessfully) {
      setRefresh(true);
      setOpen(false);
      _clearAction();
    }
  }, [action, searchText]);

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "companyCode",
      headerName: I18nTranslator(translations.masterData.companyID),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "companyName",
      headerName: I18nTranslator(translations.masterData.companyName),
      size: "full",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "companyAddress",
      headerName: I18nTranslator(translations.masterData.address),
      size: "full",
      align: "left",
    }),
    TableHelper.renderActivationCell(),
  ];
  return (
    <Fragment>
      <AppTable<ICompany>
        title={I18nTranslator(translations.masterData.companyConfiguration)}
        loading={loading}
        data={result}
        columns={COLUMNS}
        onAddNewClick={onClickAddNew}
        onSearch={handleSearchTextChange}
        searchPlaceholder={I18nTranslator(
          translations.placeholder.searchContact
        )}
        onChangePage={handlePageChange}
        onRowPressEdit={onPressEdit}
        onRowPressDelete={onPressDelete}
        hideImport
        onPageSizeChange={_handlePageSizeChange}
        actionColumnProps={{ hideImport: true }}
        onDownloadClick={_downloadCompanyMasterData}
        isDownloading={downloading}
      />
      <DeleteConfirmDialog
        open={open}
        value={itemSelected?.companyName}
        handleClose={handleClose}
        handleDelete={handleDeleteCompany}
        isDeleting={action.includes(
          MasterDataActions.deleteCompany.requestName
        )}
      />
    </Fragment>
  );
};

export default CustomerConfiguration;
